import { useContactSupport } from '@/hooks/useContactSupport';


export default function SupportCard() {
  const { whatsapp, handleWhatsAppSupportClick, handleTelegramSupportClick } = useContactSupport();

  return (
    <div
      className="relative mt-[1.125rem] overflow-hidden rounded-[1.25rem] bg-[#1e1f22] px-4 pb-4 pt-4"
      style={{
        backgroundImage:
          'radial-gradient(circle at 85% 80%, rgba(0,110,255,0.45), rgba(0,110,255,0) 55%)',
      }}
    >
      <div className="flex items-center gap-2">
        <h3 className="text-lg font-semibold text-white">Support</h3>
        <span className="rounded-full bg-[#0a6cff] px-2.5 py-0.5 text-sm font-bold text-white">
          24/7
        </span>
      </div>
      <p className="mt-1.5 w-1/2 text-sm leading-snug text-[#9aa0ad]">
        Contact us if you still have questions
      </p>

      <img
        src="/images/support-agent.jpg"
        alt=""
        className="pointer-events-none absolute right-0 top-0 h-[8rem] w-[52%] object-cover [mask-image:linear-gradient(to_right,transparent,black_45%,black_85%,transparent)]"
        style={{ objectPosition: "100% 20%" }}
      />

      <button
        type="button"
        onClick={whatsapp ? handleWhatsAppSupportClick : handleTelegramSupportClick}
        className="relative mt-[4.25rem] h-11 w-full rounded-xl bg-[#0a6cff] text-base font-semibold text-white active:scale-[0.98]"
      >
        Contact support
      </button>
    </div>
  );
}
